import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GenProvider } from 'providers/gen/gen';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html'
})
export class AppHeaderComponent implements OnInit {
  nome: any;
  foto: string;
  constructor( public genProvider: GenProvider, private router: Router) {

   }
   ngOnInit(): void {
     setTimeout(() => {
    this.nome = this.genProvider.parametros.nome
    if (this.nome){
      this.foto = 'assets/perfil/' + this.nome.trim().toUpperCase().substring(0, 1) + '.jpg';
    }
     }, 1000);
    }
}



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/app/components/app-header/app-header.component.ts